import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CustomerGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private location: Location) { }

  canActivate(): boolean {
    const usrSession = this.authService.getDataSesion();
    if (usrSession.role === 'customer' || usrSession.role === 'admin') {
      return true;
    }
    // this.location.back();
    this.router.navigate(['/login']);
    // this.authService.signOut();
    return false;
  }

}
